"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Generates a rainbow background, covering the hue spectrum from 0 to 360
var getSpecturm = function getSpecturm() {
  var spectrum = '';
  spectrum = 'linear-gradient(to right, ';

  for (var h = 0; h < 360; h += 20) {
    spectrum += "".concat(h ? ',' : '', " hsl(").concat(h, ", 100%, 50%)");
  }

  spectrum += ')';
  return spectrum;
};

var _default = {
  ColorInput: {
    display: 'inline-flex',
    alignItems: 'stretch',
    justifyContent: ''
  },
  ColorPreview: {
    width: 30,
    background: 'black',
    border: '1px solid #F9F9F9',
    borderRadius: '0 6px 6px 0',
    position: 'relative',
    cursor: 'pointer',

    /* hide color picker */
    '& > *': {
      display: 'none'
    },

    /* show color picker when preview or any child has the focus */
    '&:focus-within > *': {
      display: 'unset',
      borderColor: '#257EEA'
    }
  },
  ColorCode: {
    flexGrow: 1,
    borderRadius: '6px 0 0 6px'
  },
  Arrow: {
    background: '#FFF',
    position: 'absolute',
    width: '20px',
    height: '20px',
    left: -10,
    top: '50%',
    marginTop: -10,
    transform: 'rotate(45deg)',
    zIndex: 0,
    boxShadow: '-3px 3px 3px rgba(0,0,0,.055)'
  },
  ColorPicker: {
    cursor: 'default',
    position: 'absolute',
    right: 0,
    marginRight: -180,
    marginTop: -57,
    background: '#FFF',
    padding: 10,
    boxShadow: '0 3px 6px rgba(0,0,0,.16)',
    borderRadius: 6
  },
  Gradient: {
    position: 'relative',
    border: '1px solid #E5E5E5',
    width: 140,
    height: 105,
    cursor: 'pointer',
    marginBottom: 9
  },
  Pointer: {
    position: 'absolute',
    width: 6,
    height: 6,
    borderRadius: 6,
    border: '1px solid #E5E5E5',
    outline: '4px solid #FFF',
    boxShadow: '0 0 0 5px #E5E5E5',
    marginLeft: -4,
    marginTop: -4
  },
  Spectrum: {
    position: 'relative',
    width: '100%',
    height: 8,
    borderRadius: 8,
    cursor: 'pointer',
    background: getSpecturm()
  }
};
exports["default"] = _default;
//# sourceMappingURL=style.js.map